import { Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { LoginService } from "src/app/modules/auth/login/login.service";
import { PermissionSetService } from "../core/permission-set.service";
import { ToasterService, ToasterType } from "../toaster/toaster.service";
import { JwtHelperService } from '@auth0/angular-jwt';
import { UserAgreementComponent } from "src/app/_metronic/core/common-modals/user-agreement/user-agreement.component";
import { CoreHelperService } from "../core/core-helper.service";
import { UserRole, UserStatus } from "src/app/_metronic/core/classes/core.class";
import { SetupAssistantData } from "src/app/_metronic/core/classes/core.class";
import { ModuleSetupData } from "src/app/_metronic/core/module-setup-guide-data";
import { AppConstant } from "src/app/app.constant";

@Injectable()
export class AuthenticationService {
   token: string;
   loginResponse: any;
   constructor(private router: Router,
      private toastr: ToasterService,
      private loginService: LoginService,
      private route: ActivatedRoute,
      public coreHelperService: CoreHelperService,
      // private registerService: RegisterService,
      private modalService: NgbModal,
      private permissionService: PermissionSetService,
      private appConstant: AppConstant
      ) { }
   loginUser(loginData) {
      // Login data will contain Username and Password
      this.loginService.authenticate(loginData).subscribe(
         response => {
            this.loginResponse = response
            // set grid filters in session storage
            if (response.data.GridFilters) {
               if (response.data.GridFilters.StudentGrid) {
                  sessionStorage.setItem('StudentGrid', JSON.stringify(response.data.GridFilters.StudentGrid))
               }
               if (response.data.GridFilters.PrincipalGrid) {
                  sessionStorage.setItem('PrincipalGrid', JSON.stringify(response.data.GridFilters.PrincipalGrid))
               }
               if (response.data.GridFilters.AdminGrid) {
                  sessionStorage.setItem('AdminGrid', JSON.stringify(response.data.GridFilters.AdminGrid))
               }
               if (response.data.GridFilters.FacultyGrid) {
                  sessionStorage.setItem('FacultyGrid', JSON.stringify(response.data.GridFilters.FacultyGrid))
               }
               if (response.data.GridFilters.AttendanceGrid) {
                  sessionStorage.setItem('AttendanceGrid', JSON.stringify(response.data.GridFilters.AttendanceGrid))
               }
               if (response.data.GridFilters.AssignmentGrid) {
                  sessionStorage.setItem('AssignmentGrid', JSON.stringify(response.data.GridFilters.AssignmentGrid))
               }
               if (response.data.GridFilters.ExamGrid) {
                  sessionStorage.setItem('ExamGrid', JSON.stringify(response.data.GridFilters.ExamGrid))
               }
               if (response.data.GridFilters.ExamMarkGrid) {
                  sessionStorage.setItem('ExamMarkGrid', JSON.stringify(response.data.GridFilters.ExamMarkGrid))
               }
            }
            // response will contain token , module access data and module tour json data
            if (this.loginResponse.status == 200) {
               const helper = new JwtHelperService();
               const tokendata = helper.decodeToken(response.data.Token);
               this.setValue(loginData, response);  // setting all the values in session storage
               this.appConstant.connectSocketHub();

               if (tokendata.Status == UserStatus['PasswordResetRequired'] && !this.loginResponse.data.IsEnteredSuperPassword) { // redirect to password reset is logged in for first time
                  this.router.navigate(['/auth/reset-password']);
               }
               else if (tokendata.UserRoleId == UserRole.SuperAdmin) { // skip verification check for super admin
                  this.routeToPage();
               }
               else {
                  this.routeToPage();
                  // this.sendVerificationCode(loginData.Username) // sending verification code to user
               }
            }
            else if (this.loginResponse.status == 201) {
               this.showAgreement(loginData) // User agreement popup
               return true;
            }
            else {
               this.toastr.showToaster('', this.loginResponse.data, ToasterType.Error);
               return true;
            }
         },
      );
   }
   sendVerificationCode(UserName) {
      this.loginService.sendVerificationCode(UserName).subscribe(
         res => {
            if (res.status == 200) {
               this.router.navigate(['/auth/verification-code']);
            }
            else {
               this.toastr.showToaster('', res.data, ToasterType.Error);
               return true;
            }
         })
   }
   verifyVerificationCode(verificationCodeData) {
      // verificationCodeData contains UserId and VerificationCode
      this.loginService.verifyVerificationCode(verificationCodeData).subscribe(
         res => {
            if (res.status == 200) {
               this.routeToPage();
            }
            else {
               this.toastr.showToaster('', res.data, ToasterType.Error);
               return true;
            }
         },
      );
   }
   showAgreement(loginData) {
      const ngbModalOptions: NgbModalOptions = {
         backdrop: 'static',
         keyboard: false,
         size: 'xl',
         scrollable: true
      };
      const modelref = this.modalService.open(UserAgreementComponent, ngbModalOptions);
      modelref.componentInstance.agreementData = this.loginResponse.data
      modelref.result.then((result) => {
         if (!this.coreHelperService.isNullOrUndefined(result)) {
            loginData.IsAgreeToTerms = true
            this.loginUser(loginData)
         }
      })
   }
   setValue(value, data) {
      sessionStorage.setItem("jwtToken", data.data.Token)
      sessionStorage.setItem("Year", new Date().getFullYear().toString())
      const helper = new JwtHelperService();
      const tokendata = helper.decodeToken(data.data.Token);

      sessionStorage.setItem('IsSetupOpened', '0')
      sessionStorage.setItem('UserRoleId', tokendata.UserRoleId);
      sessionStorage.setItem('UserId', tokendata.UserId);
      sessionStorage.setItem('UserProfileImage', tokendata.UserProfileImage);
      sessionStorage.setItem('Name', tokendata.FirstName + ' ' + tokendata.LastName)
      sessionStorage.setItem('InstituteId', tokendata.InstituteId);
      sessionStorage.setItem('AcademicYearId', tokendata.AcademicYearId)
      sessionStorage.setItem('academicYearCode', tokendata.AcademicYearCode)
      sessionStorage.setItem('BranchId', tokendata.BranchId);
      sessionStorage.setItem('Username', value.Username)
      sessionStorage.setItem('BranchName', tokendata.BranchName)
      sessionStorage.setItem('HasMultiBranch', tokendata.HasMultiBranch)
      sessionStorage.setItem('IsFirstTimeLogin', tokendata.IsFirstTimeLogin)
      sessionStorage.setItem('Environment', tokendata.Environment)
      sessionStorage.setItem('InstituteName', tokendata.InstituteName)
      sessionStorage.setItem('BranchName', tokendata.BranchName)
      sessionStorage.setItem('EnableJodo', tokendata?.EnableJodo)
      sessionStorage.setItem('StudentFeedbackEnabled', tokendata?.StudentFeedbackEnabled)
      if(data.data.InstituteLogo){
         localStorage.setItem('logo',data.data.InstituteLogo)
      }
      if (this.coreHelperService.isNullOrUndefined(data.data.ModuleTourJson)) {
         const moduleSetupData = ModuleSetupData.map(ele => {
            return {
               Index: ele.Index,
               Module: ele.Module,
               IsTourDone: ele.IsTourDone,
            };
         });
         sessionStorage.setItem('ModuleTourJson', JSON.stringify(moduleSetupData))
      }
      else {
         let moduleTourJson = JSON.parse(data.data.ModuleTourJson)
         const results = ModuleSetupData.filter(({ Index: id1 }) => !moduleTourJson.some(({ Index: id2 }) => id2 === id1));
         const moduleSetupData = results.map(ele => {
            return {
               Index: ele.Index,
               Module: ele.Module,
               IsTourDone: ele.IsTourDone,
            };
         });
         let updatedModuleSetupData = [...moduleTourJson, ...moduleSetupData]
         sessionStorage.setItem('ModuleTourJson', JSON.stringify(updatedModuleSetupData))
      }

   }
   routeToPage() {
      const helper = new JwtHelperService();
      const tokendata = helper.decodeToken(sessionStorage.getItem('jwtToken'));
      if (tokendata.IsPasswordResetRequire) {
         this.router.navigate(['/auth/reset-password']);
         return true
      }
      if (tokendata.HasMultiBranch) {
         this.router.navigate(['/dashboard']);
      }
      if (tokendata.UserRoleId < UserRole.Faculty) {
         sessionStorage.setItem('SetupAssistantData', JSON.stringify(SetupAssistantData))
      }
      if (tokendata.UserRoleId == UserRole.Faculty) {
         sessionStorage.setItem('FacultyId', tokendata.FacultyId)
      }
      if (tokendata.UserRoleId == UserRole.Student) {
         sessionStorage.setItem('ClassId', tokendata.ClassId)
         sessionStorage.setItem('SectionIds', tokendata.SectionIds)
      }
      if (tokendata.UserRoleId == UserRole.Branch) {
         sessionStorage.setItem('BranchName', tokendata.FirstName + ' ' + tokendata.LastName)
      }
      if (tokendata.UserRoleId > UserRole.Branch) {
         this.permissionService.getPermissionSetById(tokendata.PermissionSetId).subscribe((accessData) => {
            sessionStorage.setItem('Permissions', accessData.AccessJson)
            this.router.navigate(['/dashboard']);
            if (tokendata.UserRoleId == UserRole.Student) {
               sessionStorage.setItem('ClassId', tokendata.ClassId);
               sessionStorage.setItem('SectionIds', tokendata.SectionIds);
               sessionStorage.setItem('StudentId', tokendata.StudentId)
               this.router.navigate(['/dashboard']);
            }
         })
      }
      else {
         if (tokendata.UserRoleId == UserRole.Institute) {
            if (tokendata.HasMultiBranch == true) {
               this.router.navigate(['/external/branches']);
            }
            else {
               this.router.navigate(['/dashboard'])
            }
         }
         else if (tokendata.UserRoleId == UserRole.SuperAdmin) {
            this.router.navigate(['/external/institutes']);
         }
         else {
            this.router.navigate(['/dashboard']);
         }
      }
   }
   resetPasswordForFirstTimeLogin(value) {
      this.loginService.resetPassword(value).subscribe
         (res => {
            if (res.status == 200) {
               sessionStorage.clear()
               this.toastr.showToaster('', "Your Password Changed Successfully", ToasterType.Success);
               this.router.navigate(['/auth/login'], {
                  queryParams: {},
               });
               return true;
            }
            else {
               this.toastr.showToaster('', res.data, ToasterType.Error);
               return true;
            }
         });
   }

   resetPassword(value) {
      this.loginService.forgotPassword(value.email).subscribe(
          (res) => {
              sessionStorage.setItem('Username', value.email);
              this.toastr.showToaster('', 'Password Link Sent To Your Registered Email Id', ToasterType.Success);
              this.router.navigate(['/auth/check-otp']);
              return true;
          },
          (error) => {
              this.toastr.showToaster('', error.error.data || 'Something went wrong, please try again!', ToasterType.Error);
              return true;
          }
      );
   }

   checkOTP(value) {
      this.loginService.verifyVerificationCode(value).subscribe(
          (res) => {
              sessionStorage.setItem('VerificationCode', value.VerificationCode);
              this.toastr.showToaster('', 'OTP Verified', ToasterType.Success);
              this.router.navigate(['/auth/change-password']);
              return true;
          },
          (error) => {
              this.toastr.showToaster('', error.error.data || 'Something went wrong, please try again!', ToasterType.Error);
              return true;
          }
      );
   }
   changePassword(value) {
      value.Password = value.NewPassword;
      this.loginService.changePassword(value).subscribe(
          (res) => {
              this.toastr.showToaster('', 'Your Password Changed Successfully', ToasterType.Success);
              this.router.navigate(['/auth/login']);
              return true;
          },
          (error) => {
              this.toastr.showToaster('', error.error.data || 'Something went wrong, please try again!', ToasterType.Error);
              return true;
          }
      );
   }
}
